export default __webpack_public_path__ + "static/media/50d.0c72cfb4.jpg";